// Single source of truth for the running build's identity. The semver comes
// from package.json; the git hash and build date are stamped in by Vite at
// build time (see vite.config.ts `define`).

export const APP_VERSION: string = __APP_VERSION__;
export const GIT_HASH: string = __GIT_HASH__;
export const BUILD_DATE: string = __BUILD_DATE__;

/** e.g. "v2.0.0" */
export const VERSION_SHORT = `v${APP_VERSION}`;

/** e.g. "v2.0.0 · ab12cd3 · 2026-06-12" */
export const VERSION_FULL = `v${APP_VERSION} · ${GIT_HASH} · ${BUILD_DATE}`;
